<!--
 * @Author       : aa
 * @Date         : 2020-06-15 12:05:17
 * @Description  : 题号列表
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\card\question_card.vue
--> 
<template>
  <div class="question_card">
    <div class="card">
      <div class="nav">题号索引</div>
      <div class="comparison">
        <div class="already"></div>
        <span>已作答</span>
        <div class="not_yet"></div>
        <span>未作答</span>
      </div>
      <!-- 文科答题卡 -->
      <div
        class="number_list_wen"
        v-if="
          subjectId == 9 ||
          subjectId == 11 ||
          subjectId == 16 ||
          subjectId == 15 ||
          subjectId == 17
        "
      >
        <div
          v-for="(qs, index) in questionStatus"
          :key="index"
          :class="{
            already: qs.status,
            not_yet: !qs.status,
            choose: qs.id == id,
          }"
          :id="'anchor' + qs.id"
          @click="gotoTarget(index)"
          v-html="`${qs.originalName}`"
        ></div>
      </div>
      <!-- 理科答题卡 -->
      <div class="number_list" v-else>
        <el-tabs
          tab-position="left"
          style="height: 100%"
          v-model="tabPosition"
          @tab-click="tabelChange"
        >
          <el-tab-pane
            v-for="(qs, key, index) in newQuestionStatus"
            :label="key"
            :name="key"
            :key="index"
          >
            <div
              v-for="(cqs, index) in newQuestionStatus[key]"
              :key="index"
              :class="{
                already: cqs.status,
                not_yet: !cqs.status,
                choose: cqs.id == id,
              }"
              :id="'anchor' + cqs.id"
              @click="gotoTarget(cqs.index)"
              v-html="`${cqs.name}`"
            ></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="btns" v-if="questionStatus.length">
      <el-button
        :disabled="index == 0"
        :class="index == 0 ? 'btn-dis' : 'btn'"
        @click="gotoTarget(index - 1)"
        >上一题</el-button
      >
      <el-button
        :disabled="index == questionStatus.length - 1"
        :class="index == questionStatus.length - 1 ? 'btn-dis' : 'btn'"
        @click="gotoTarget(index + 1)"
        >下一题</el-button
      >
      <el-button
        v-if="question_type != 1 || question_type != 2 || question_type != 3"
        class="btn"
        @click="save_paper()"
        >保存</el-button
      >
      <el-button
        v-if="appId == 200 || appId == 400"
        class="btn"
        @click="shamBattleDialogShow()"
        >交卷</el-button
      >
      <el-button v-else class="btn" @click="submit_paper()">交卷</el-button>
      <el-button
        v-if="
          model == 'client' &&
          curPath.indexOf('test.gk211985.com') != -1 &&
          appId != 400
        "
        class="btn"
        @click="sendMessageToClient()"
        >辅导</el-button
      >
    </div>
    <el-dialog
      :close-on-press-escape="true"
      style="margin-top: 60px"
      :append-to-body="true"
      center
      custom-class="success-serve-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogServeVisible"
      v-loading="saveLoading"
    >
      <!-- :show-close="false" -->
      <div>
        <div class="title">
          <img src="../../../assets/images/paper/submit-ok.png" alt />
          <h3>保存成功</h3>
        </div>
        <div class="table-container">
          <div class="item">
            <div class="count">
              本套试卷客观题共{{ savePaperInfo.objective.count }}题
            </div>
            <div class="number">
              作答{{ savePaperInfo.objective.complete }}题
            </div>
            <div class="unnumber">
              未作答{{ savePaperInfo.objective.uncomplete }}题
            </div>
          </div>
          <div class="item">
            <div class="count">
              本套试卷主观题共{{ savePaperInfo.major.count }}题
            </div>
            <div class="number">作答{{ savePaperInfo.major.complete }}题</div>
            <div class="unnumber">
              未作答{{ savePaperInfo.major.uncomplete }}题
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="keepon">继续答题</el-button>
        <el-button type="primary" @click="gohome">结束答题</el-button>
      </span>
    </el-dialog>
    <!-- 测评报告 -->
    <!-- <el-dialog
      :close-on-press-escape="true"
      center
      custom-class="success-submit-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogSubmitVisible"
      :show-close="false"
    >
      <div v-if="allStatus" v-loading="submitLoading">
        <div class="top">
          <img src="../../../assets/images/client/report-success.jpg" alt="">
          <h3>你已交卷</h3>
          <div v-if="appId == 100" class="lv">本次得分率=<span class="value">{{ `${submitPaperInfo.objective.corrected_score != 0 && submitPaperInfo.objective.corrected_score ? ((submitPaperInfo.objective.correct_uncheck / submitPaperInfo.objective.corrected_score) * 100).toFixed(2) : 0}%` }}</span></div>
          <div v-if="appId == 100" class="tip">本次得分率=本次测评作答题目的实际总得分÷本次测评作答题目的总赋分</div>
        </div>
        <div class="center"></div>
        <div class="bottom">
          <div class="header">
            本套试卷满分<span class="fs20" style="color: #585858">{{ fullScore }}</span>分，你已得到<span class="fs20" style="color: #52c41a">{{ correctScore }}</span>分，失<span class="fs20" style="color: #ff0000">{{ errorScore }}</span>分，待批改<span class="fs20" style="color: #585858">{{ unCheckScore }}</span>分，未作答<span class="fs20" style="color: #585858">{{ submitPaperInfo.objective.no_do_score + submitPaperInfo.major.error_score }}</span>分
          </div>
          <div class="kgbox">
            <div class="title">客观题总共<span class="fs20">{{ submitPaperInfo.objective.score }}</span>分</div>
            <div class="kgbox-c" v-if="submitPaperInfo.objective.correct_uncheck">
              <span class="left">得<span class="fs20" style="color: #52c41a">{{ submitPaperInfo.objective.correct_uncheck }}</span>分</span>
              <div class="right">
                序号： <span v-for="(number, index) in submitPaperInfo.objective.correct_number" :key="index">{{ number }}</span>
              </div>
            </div>
            <div class="kgbox-c bgColor" v-if="submitPaperInfo.objective.error_score">
              <span class="left">失<span class="fs20" style="color: #ff0000">{{ submitPaperInfo.objective.error_score }}</span>分</span>
              <div class="right">
                序号： <span v-for="(number, index) in error_number" :key="index">{{ number }}</span>
              </div>
            </div>
            <div class="kgbox-c" v-if="submitPaperInfo.objective.no_do_score">
              <span class="left">未作答<span class="fs20" style="color: #a6a6a6">{{ submitPaperInfo.objective.no_do_score }}</span>分</span>
              <div class="right">
                序号： <span v-for="(number,index) in submitPaperInfo.objective.no_do_score_arr" :key="index">{{ number }}</span>
              </div>
            </div>
          </div>
          <div class="zgbox">
            <div class="title">主观题总共<span class="fs20">{{ submitPaperInfo.major.score }}</span>分</div>
            <div class="kgbox-c" v-if="submitPaperInfo.major.correct_uncheck">
              <span class="left">待批改<span class="fs20" style="color: #a6a6a6">{{ submitPaperInfo.major.correct_uncheck }}</span>分</span>
              <div class="right">
                序号： <span v-for="(number, index) in submitPaperInfo.major.uncheck_number" :key="index">{{ number }}</span>
              </div>
            </div>
            <div class="kgbox-c" v-if="submitPaperInfo.major.error_score">
              <span class="left">未作答<span class="fs20" style="color: #a6a6a6">{{ submitPaperInfo.major.error_score }}</span>分</span>
              <div class="right">
                序号： <span v-for="(number,index) in submitPaperInfo.major.uncomplete" :key="index">{{ number }}</span>
              </div>
            </div>
          </div>
          <div v-if="appId == 400" style="width: 100%; color: red; font-size: 20px; text-align:center; line-height: 40px">
            关闭后，去我的测评中自评或查看结果
          </div>
          <div class="footerButton">
            <template v-if="appId != 400">
              <button v-if="!audit_status" @click="toSelfAssessment">自评主观题</button>
              <button v-if="audit_status" @click="toSelfResult">查看结果</button>
              <button @click="toWorngQuestion">查看错题</button>
            </template>
            <template v-else>
              <button @click="closeWindow">关闭</button>
            </template>
          </div>
        </div>
      </div>
      <div v-else class="evaluation-img">
        <img src="../../../assets/images/client/no-c.jpg" alt="">
        <button @click="toSelfResult">查看结果</button>
      </div>
    </el-dialog> -->
    <el-dialog
      :close-on-press-escape="true"
      center
      custom-class="success-submit-new-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogSubmitVisible"
      :show-close="appId == 100"
      @close="backExpertList"
      top="20px"
    >
      <!-- :fullscreen="true" -->
      <div v-loading="submitLoading">
        <div class="paper-name">{{ userName }}</div>
        <div class="paper-name">{{ pName }}</div>
        <div class="pop-name">{{ appId == 100 ? "测评报告" : "测试结果" }}</div>
        <div class="content" v-if="appId == 200 && audit_status">
          <h3>本次测评结果</h3>
          <p class="new-tip">
            你的本次实战演练总得分为{{
              pData.objectiveGetScore +
              pData.subjectiveGetScore +
              pData.objectiveHalfScore +
              pData.subjectiveHalfScore
            }}分，预测你目前参加高考时你本学科的总得分在“{{
              scoreRate.expectGkScore
            }}”分左右，请根据你的错题有针对性利用提分宝典和专家测评模块进行复习，以取得更好的成绩。
          </p>
        </div>
        <!-- 本次测评结果什么时候出  B界面有 -->
        <div
          class="content"
          v-if="audit_status && paperType != 1 && appId != 400"
        >
          <h3>本次测评结果</h3>
          <div class="scoring">
            本次测评得分率<span>{{ pData.scoringRate }}%</span>
          </div>
          <div class="ping-msg">
            <div class="item-msg" v-if="+pData.scoringRate < 65">
              你的“{{
                pName
              }}专题板块”还有很大的提分空间，是需要你重点关注的部分。
            </div>
            <div
              class="item-msg"
              v-else-if="+pData.scoringRate > 65 && +pData.scoringRate < 85"
            >
              你的“{{ pName }}专题板块”得分能力尚可，但还有提升空间。
            </div>
            <div class="item-msg" v-else-if="+pData.scoringRate >= 85">
              你的“{{ pName }}专题板块”得分能力优秀。
            </div>

            <div v-if="+pData.scoringRate < 65" class="item-cont">
              <span class="item">备考建议：</span>
              请在智能错题本中聆听名师精讲，认真重做错题，并利用提分宝典中的本专题相关辅导资源重点复习相关内容。之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
            </div>
            <div
              class="item-cont"
              v-else-if="+pData.scoringRate > 65 && +pData.scoringRate < 85"
            >
              <span class="item">备考建议：</span>
              请在智能错题本中聆听名师精讲，认真重做错题，并选择提分宝典中适合自己的辅导资源针对性学习，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
            </div>
            <div
              class="item-cont"
              v-else-if="+pData.scoringRate >= 85 && +pData.scoringRate < 100"
            >
              <span class="item">备考建议：</span>
              请在智能错题本中聆听名师精讲，认真修改错题，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
            </div>
            <div class="item-cont" v-else-if="+pData.scoringRate == 100">
              <template v-if="isComplete">
                <span class="item">备考建议：</span>
                请在我的学习中聆听本专题名师精讲，巩固提升。之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果。
              </template>
              <template v-else>
                <span class="item">备考建议：</span>
                请在我的学习中聆听本专题名师精讲，巩固提升。
              </template>
            </div>
          </div>
        </div>
        <div
          class="content"
          v-if="audit_status && paperType == 1 && appId != 200 && appId != 400"
        >
          <h3>本次测评结果</h3>
          <p>
            本套测评卷共<span>{{ questionNumber }}</span
            >道题目（含小题）
          </p>
          <p>
            本次测评实做<span>{{
              pData.objectiveOriginalNameArr.length +
              pData.subjectiveOriginalNameArr.length
            }}</span
            >道题， 做对<span class="blue">{{
              pData.objectiveGetNumber.length
            }}</span
            >道， 半对<span class="red">{{
              pData.objectiveHalfArr.length
            }}</span
            >道
          </p>
          <p>
            本次测评得分<span>{{
              pData.objectiveGetScore + pData.subjectiveGetScore
            }}</span
            >分
          </p>
        </div>
        <div class="content" v-if="appId == 400 && audit_status">
          <h3>本次测评结果</h3>
          <div class="scoring">
            本次测评得分率<span>{{ pData.scoringRate }}%</span>
          </div>
          <div class="ping-msg">
            <div class="item-cont" v-if="+pData.scoringRate <= 65">
              <span class="item">备考建议：</span
              >你的此部分知识基础还很薄弱，请打开提分宝典，认真学习一轮复习相关内容，并结合课本认真学习基本概念。  
            </div>
            <div
              class="item-cont"
              v-else-if="+pData.scoringRate > 60 && +pData.scoringRate <= 75"
            >
              <span class="item">备考建议：</span
              >你的此部分知识基础尚可，请认真学习提分宝典中一轮复习相关内容，打开错题本认真修改错题。 
            </div>
            <div
              class="item-cont"
              v-else-if="+pData.scoringRate > 75 && +pData.scoringRate <= 90"
            >
              <span class="item">备考建议：</span
              >你的此部分知识基础良好，请打开错题本认真修改错题，并继续去专家测评系统中相关专题内容中进行测评。
            </div>
            <div class="item-cont" v-else>
              <span class="item">备考建议：</span
              >你的此部分知识很扎实，无需再做此部分内容的试题，只需认真修改错题
            </div>
          </div>
        </div>
        <div class="content">
          <h3>本次测评概况</h3>
          <p v-if="pData.objectiveOriginalNameArr.length">
            本次测评客观题共<span>{{
              pData.objectiveGetNumber.length +
              pData.objectiveHalfArr.length +
              pData.objectiveLoseNumber.length
            }}</span
            >题， 答对<span class="blue">{{
              pData.objectiveGetNumber.length
            }}</span
            >题， 得分<span class="blue">{{ pData.objectiveGetScore }}</span
            >分， 半对<span class="red">{{
              pData.objectiveHalfArr.length
            }}</span
            >题， 得<span class="red">{{ pData.objectiveHalfScore }}</span
            >分， 答错<span class="red">{{
              pData.objectiveLoseNumber.length
            }}</span
            >题，失<span class="red">{{ pData.objectiveLoseScore }}</span
            >分
          </p>
          <div class="content-box" v-if="pData.objectiveOriginalNameArr.length">
            <span class="left">客观题：</span>
            <div class="show-status">
              <div
                class="item"
                v-for="(objective, index) in pData.objectiveOriginalNameArr"
                :key="index"
              >
                <span
                  :class="[
                    'origin-name',
                    { bgred: objective.status == 3 },
                    { bgblue: objective.status == 0 },
                    { bgblack: objective.status == 4 },
                    { bgbandui: objective.status == 1 },
                  ]"
                  >{{ objective.originalName }}</span
                >
                <!-- 状态 0 正确； 1 半对； 2 未作 ； 3 错误 ;4 未自评 -->
                <div class="origin-img">
                  <img
                    v-if="objective.status == 0"
                    class="w22"
                    src="@/assets/images/paper/p-dui.jpg"
                  />
                  <img
                    v-if="objective.status == 3"
                    class="w17"
                    src="@/assets/images/paper/p-cuo.jpg"
                  />
                  <img
                    v-if="objective.status == 1"
                    class="w22"
                    src="@/assets/images/paper/p-bandui.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
          <p v-if="pData.subjectiveOriginalNameArr.length">
            本次测评主观题共{{
              pData.subjectiveWaitingNumber.length
            }}题，待自评{{ pData.subjectiveWaitingNumber.length }}题。
          </p>
          <div
            class="content-box"
            v-if="pData.subjectiveOriginalNameArr.length"
          >
            <span class="left">主观题：</span>
            <div class="show-status">
              <div
                class="item"
                v-for="(subjective, index) in pData.subjectiveOriginalNameArr"
                :key="index"
              >
                <span
                  :class="[
                    'origin-name',
                    { bgred: subjective.status == 3 },
                    { bgblue: subjective.status == 0 },
                    { bgblack: subjective.status == 4 },
                    { bgbandui: subjective.status == 1 },
                  ]"
                  >{{ subjective.originalName }}</span
                >
                <!-- 状态 0 正确； 1 半对； 2 未作 ； 3 错误 ;4 未自评 -->
                <div class="origin-img">
                  <img
                    v-if="subjective.status == 0"
                    class="w22"
                    src="@/assets/images/paper/p-dui.jpg"
                  />
                  <img
                    v-if="subjective.status == 3"
                    class="w17"
                    src="@/assets/images/paper/p-cuo.jpg"
                  />
                  <img
                    v-if="subjective.status == 1"
                    class="w22"
                    src="@/assets/images/paper/p-bandui.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
          <table
            class="content-tabel"
            border="0"
            v-if="
              questionType.length &&
              audit_status &&
              (appId == 200 || (appId == 100 && paperType == 1))
            "
          >
            <tr class="th-header">
              <th class="q-type">题型</th>
              <th class="q-rate">得分率</th>
              <th>诊断</th>
            </tr>
            <tr v-for="(question, index) in questionType" :key="index">
              <td align="center">{{ question.name }}</td>
              <td class="q-td-rate" align="center">
                {{ question.obtainScoreRate }}%
              </td>
              <td
                class="q-tip"
                v-if="
                  (question.type == 'A' ||
                    question.type == 'B' ||
                    question.type == 'C' ||
                    question.id == 40) &&
                  question.obtainScoreRate < 70
                "
              >
                “你的{{ question.name }}题型”是你的失分重点，请{{
                  appId == 100 ? "在智能错题本中聆听名师精讲，" : ""
                }}认真重做错题，并根据错题的考点在提分宝典中找到相关辅导资源重点复习该考点，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果
              </td>
              <td
                class="q-tip"
                v-if="
                  (question.type == 'A' ||
                    question.type == 'B' ||
                    question.type == 'C' ||
                    question.id == 40) &&
                  question.obtainScoreRate >= 70 &&
                  question.obtainScoreRate <= 90
                "
              >
                “你的{{ question.name }}题型”还有提分空间，请{{
                  appId == 100 ? "在智能错题本中聆听名师精讲，" : ""
                }}认真重做错题，并在提分宝典中的试题精选中重点选择{{
                  question.name
                }}题型练习，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果
              </td>
              <td
                class="q-tip"
                v-if="
                  (question.type == 'A' ||
                    question.type == 'B' ||
                    question.type == 'C' ||
                    question.id == 40) &&
                  question.obtainScoreRate > 90
                "
              >
                “你的{{ question.name }}题型”得分能力很强，请{{
                  appId == 100 ? "在智能错题本中聆听名师精讲，" : ""
                }}认真重做错题，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果
              </td>
              <td
                class="q-tip"
                v-if="
                  question.type != 'A' &&
                  question.type != 'B' &&
                  question.type != 'C' &&
                  question.id != 40 &&
                  question.obtainScoreRate <= 60
                "
              >
                “你的{{ question.name }}题型”是你的失分重点，请{{
                  appId == 100 ? "在智能错题本中聆听名师精讲，" : ""
                }}认真重做错题，并根据错题的考点在提分宝典中找到相关辅导资源重点复习该考点，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果
              </td>
              <td
                class="q-tip"
                v-if="
                  question.type != 'A' &&
                  question.type != 'B' &&
                  question.type != 'C' &&
                  question.id != 40 &&
                  question.obtainScoreRate > 60 &&
                  question.obtainScoreRate <= 85
                "
              >
                “你的{{ question.name }}题型”还有提分空间，请{{
                  appId == 100 ? "在智能错题本中聆听名师精讲，" : ""
                }}认真重做错题，并在提分宝典中的试题精选中重点选择{{
                  question.name
                }}题型练习，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果
              </td>
              <td
                class="q-tip"
                v-if="
                  question.type != 'A' &&
                  question.type != 'B' &&
                  question.type != 'C' &&
                  question.id != 40 &&
                  question.obtainScoreRate > 85
                "
              >
                “你的{{ question.name }}题型”得分能力很强，请{{
                  appId == 100 ? "在智能错题本中聆听名师精讲，" : ""
                }}认真重做错题，之后继续完成本套试卷中未作答和做错的测试题目，以得到最终测评结果
              </td>
            </tr>
          </table>
          <div class="button">
            <button v-if="appId == 100" @click="backExpertList">
              回到试卷列表
            </button>
            <button
              class="right"
              v-if="!audit_status"
              @click="toSelfAssessment"
            >
              去自评
            </button>
            <!-- <button v-if="audit_status" @click="toSelfResult">查结果</button> -->
            <button
              v-if="
                pData.objectiveHalfArr.length +
                  pData.objectiveLoseNumber.length >
                  0 && audit_status
              "
              class="right"
              @click="toWorngQuestion"
            >
              看错题
            </button>
            <!-- <template v-if="appId != 400"></template>
          <template v-else>
            <button @click="closeWindow">关闭</button>
          </template> -->
          </div>
        </div>

        <div class="content" v-if="audit_status && appId == 100">
          <h3>累计测评情况</h3>
          <div class="scoring">
            目前累计得分率<span>{{ scoreRate.totalObtainScoreRate }}%</span>
          </div>
          <!-- 综合卷测评报告 -->
          <div class="ping-yu" v-if="paperType == 1">
            <template
              v-if="
                pData.objectiveOriginalNameList.length -
                  pData.objectiveOriginalNameArr.length +
                  (pData.subjectiveOriginalNameList.length -
                    pData.subjectiveOriginalNameArr.length) >
                0
              "
            >
              你尚有{{
                pData.objectiveOriginalNameList.length -
                pData.objectiveOriginalNameArr.length +
                (pData.subjectiveOriginalNameList.length -
                  pData.subjectiveOriginalNameArr.length)
              }}题未完成，如果你想根据此卷测评结果预测你本学科的高考得分，请完成本卷全部测评题目。
            </template>
            <template v-else>
              你已完成本综合卷全部测评试题，通过本次综合测评，预测你本学科的高考成绩为{{
                scoreRate.expectGkScore
              }}分。
            </template>
          </div>
          <!-- 专题卷测评报告 -->
          <div class="ping-yu" v-else>
            <template
              v-if="
                pData.objectiveOriginalNameList.length -
                  pData.objectiveOriginalNameArr.length +
                  (pData.subjectiveOriginalNameList.length -
                    pData.subjectiveOriginalNameArr.length) >
                0
              "
            >
              你尚有{{
                pData.objectiveOriginalNameList.length -
                pData.objectiveOriginalNameArr.length +
                (pData.subjectiveOriginalNameList.length -
                  pData.subjectiveOriginalNameArr.length)
              }}题未完成，你应该在二模之前完成本专题全部测评题目，以得到本专题最终测评结果，及早查缺补漏。
            </template>
            <template v-else>
              <template v-if="scoreRate.totalObtainScoreRate < 85">
                你已完成本专题全部测评试题，请在智能错题本中重点聆听错题（包括已改正过的错题）对应的名师精讲，并重做错题，直到错题彻底搞懂
              </template>
              <template
                v-else-if="
                  scoreRate.totalObtainScoreRate >= 85 &&
                  scoreRate.totalObtainScoreRate < 100
                "
              >
                你已完成本专题全部测评试题，你此部分专题已经基本过关，建议不用在此专题再花更多时间
              </template>
              <template v-else>
                你已完成本专题全部测评试题，你此部分专题已经完全过关，建议不用在此专题再花更多时间
              </template>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-press-escape="true"
      center
      title="交卷"
      custom-class="battle-sham-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="shamBattleDialog"
      :show-close="false"
      v-loading="submitLoading"
    >
      <div class="content">
        <p>本套测试题共{{ questionStatus.length }}题，你已完成{{ completedQuestions }}题，尚有{{ questionStatus.length - completedQuestions }}题未完成测试，请点击继续测试按钮继续完成全部测试题目后再交卷，以得到最终测试结果。</p>
        <p>如你希望先保存以后再继续测试，请点击保存按钮，下次可继续完成未做完的测试题目。</p>
        <p>如果你确定已全部完成（有未做题目但属于不会做的），请点击“确认交卷“后查看本次测试结果。</p>
      </div>
      <div class="button">
        <button @click="shamBattleDialog = false">继续测试</button>
        <button @click="shamBattleServe">保存</button>
        <button @click="shamBattleSubmit">确认交卷</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    subjectId: Number,
    newQuestionStatus: Object,
    questionStatus: Array,
    questionSubmitInfo: Object,
    fullScore: Number,
    majorQuesitonScore: Number,
    costTime: Number,
    // appId: Number,
    pName: String,
    paperType: Number,
    questionNumber: Number,
    testId: Number,
  },
  data() {
    return {
      appId: 100,
      model: "",
      curPath: "",
      answerTimes: 0,
      monthNum: 0,
      monthCardNum: 0,
      userInfo: {},
      isAgent: false,
      agentInfo: {},
      tabPosition: "0",
      id: 0,
      question_tab: 1,
      index: 0,
      dialogServeVisible: false,
      dialogSubmitVisible: false, // 显示提交之后的数据 true
      submitLoading: false,
      saveLoading: false,
      savePaperInfo: {
        major: {
          count: 0,
          complete: 0,
          uncomplete: 0,
        },
        objective: {
          count: 0,
          complete: 0,
          uncomplete: 0,
        },
      },
      tableSavePaperData: [],
      correctScore: 0,
      errorScore: 0,
      unCheckScore: 0,

      submitPaperInfo: {
        objective: {
          // 客观题
          score: 0,
          scoringRate: 0,
          correct_uncheck: 0,
          error_score: 0,
          correct_number: [],
          error_number: [],
          uncomplete: [],
          corrected_score: 0, // 做了的客观题的分数
        },
        major: {
          // 主观题
          score: 0,
          correct_uncheck: 0,
          error_score: 0,
          uncheck_number: [],
          uncomplete: [],
        },
      },
      error_number: [],
      audit_status: true,
      allStatus: false,
      isComplete: false, // 是否有未做答的 false 没有
      orderNumber: "",
      // 以下是测评报告新加的数据
      userName: null,
      pData: {
        total: 0, // 总分
        selfTotalScore: 0, // 已得分数
        selfTotalLoseScore: 0, // 已失分数
        objectiveScore: 0, // 客观题总分
        objectiveLoseScore: 0, // 客观题已经失去的分数
        objectiveGetScore: 0, // 客观题已得到分数
        objectiveLoseNumber: [], // 客观题已失去分数的题
        objectiveGetNumber: [], // 客观题已得到分数的题
        objectiveGetNoStatusScore: 0, // 客观题未作答分数
        objectiveGetNoStatusArr: [], // 客观题未作答数组
        subjectiveScore: 0, // 主观题总分
        subjectiveGetScore: 0, // 主观题得到的分数
        subjectiveLoseScore: 0, // 主观题失去的分数
        subjectiveHalfScore: 0, // 主观题半对的分数
        subjectiveHalfArr: [], // 主观题半对的数组
        subjectiveWaitingScore: 0, // 主观题待批改分数
        subjectiveWaitingNumber: [], // 主观题待批改数组的题
        scoringRate: 0, // 得分率
        noAnswerArr: [],
        noAnswerScore: [],
        objectiveOriginalNameList: [],
        subjectiveOriginalNameList: [],
        objectiveOriginalNameArr: [],
        subjectiveOriginalNameArr: [],
        objectiveHalfScore: 0, // 客观题半对得到的分数
        objectiveHalfArr: [],
      }, // 测评报告数据
      scoreRate: {
        // 综合测评报告
        testNum: 0,
        expectGkScore: 0,
        totalObtainScoreRate: 0,
        synthesize: 0,
      },
      shamBattleDialog: false,
      completedQuestions: 0,
      questionType: [],
      submited: false,
    };
  },
  methods: {
    backExpertList() {
      console.log("this.$route.query.origin ==> ", this.$route.query.origin);
      if (!!this.$route.query.origin) {
        this.$router.push({
          path: "/my_evaluation?label=uncomplete",
        });
      } else {
        this.$router.push({
          path: "/tfedu_common/expert",
          query: { id: this.subjectId },
        });
      }
    },
    // 走保存接口
    async shamBattleServe() {
      // try {
      //   cefJS.sendmsg("savetest");
      // } catch (error) {
      //   console.log(error);
      // }
      this.$emit("clearTimer");
      let qs = this.questionStatus;
      //总体数,客观题 : 数量,已作答数,客观题: 数量,已作答数
      let questionNumber = 0;
      let objectiveNumber = 0;
      let objectiveRespondNumber = 0;
      let objectiveNoRespondNumber = 0;
      let majorNumber = 0;
      let majorRespondNumber = 0;
      let majorNoRespondNumber = 0;
      questionNumber = qs.length;
      qs.forEach((q) => {
        if (this.questionIsMajor(q)) {
          majorNumber++;
          if (q.status) {
            majorRespondNumber++;
          }
        } else {
          if (q.status) {
            objectiveRespondNumber++;
          }
        }
      });
      objectiveNumber = questionNumber - majorNumber;
      majorNoRespondNumber = majorNumber - majorRespondNumber;
      objectiveNoRespondNumber = objectiveNumber - objectiveRespondNumber;

      this.savePaperInfo = {
        major: {
          count: majorNumber,
          complete: majorRespondNumber,
          uncomplete: majorNoRespondNumber,
        },
        objective: {
          count: objectiveNumber,
          complete: objectiveRespondNumber,
          uncomplete: objectiveNoRespondNumber,
        },
      };
      this.submitLoading = true;
      let paper_submit_data = {
        paper_id: this.questionSubmitInfo.paper_id,
        test_id: this.testId,
        user_id: this.questionSubmitInfo.user_id,
        audit_status: false, //批改状态为false
        questions: this.questionStatus,
        time_used: this.costTime,
      };
      await this.$HTTP
        .executePost(this.$APIS.PAPER_SAVE, paper_submit_data, this)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功！");
            this.$router.push({
              path: "/savesuccess",
            });
          } else {
            this.$message.error("保存失败请重试！");
          }
          this.submitLoading = false;
        });
    },
    // 提交数据分析
    submitDataAnalysis() {
      let objectiveGetScore = 0; // 客观得到分数
      let objectiveScore = 0; // 客观题总分
      let objectiveLoseScore = 0; // 客观错误的分数
      let objectiveLoseNumber = []; // 客观错误的数组
      let objectiveGetNoStatusScore = 0; // 客观未作答分数
      let objectiveGetNoStatusArr = []; //  客观未作答数组
      let objectiveGetNumber = []; // 客观得分题目数组
      let objectiveOriginalNameList = []; // 客观题题目状态数组 "originalName": "string", "status": 0
      let objectiveDo = 0; // 客观题已经做的分数
      let objectiveHalfScore = 0; // 客观题半对
      let objectiveHalfArr = []; // 客观题半对数组
      // 主观题计算
      let subjectiveGetScore = 0; // 主观题得到的分数
      let subjectiveLoseScore = 0; // 主观题失去的分数
      let subjectiveHalfScore = 0; // 主观题半对的分数
      let subjectiveWaitingScore = 0; // 主观题待批改分数
      let subjectiveWaitingNumber = []; // 主观题待批改分数题目数组
      let subjectiveOriginalNameList = []; // 主观题题目状态数组
      let subjectiveHalfArr = []; // 主观题半对的数组
      let noAnswerArr = []; // 未作答数组
      let noAnswerScore = 0; // 未作答分数
      // 新增两个类型
      for (let i = 0; i < this.questionStatus.length; i++) {
        const qs = this.questionStatus[i];
        if (
          qs.type_code == "A" ||
          qs.type_code == "B" ||
          qs.type_code == "C" ||
          qs.type_id == 40
        ) {
          // 是客观题
          objectiveScore += qs.question_score; // 客观题总分
          if (qs.status) {
            // 客观题已经做的分数
            objectiveDo += qs.question_score;
          }

          if (qs.score) {
            // 得到的总分数
            objectiveGetScore += qs.score;
            objectiveGetNumber.push(
              qs.parentName != null && qs.parentName
                ? `${qs.parentName}.${qs.originalName}`
                : `${qs.originalName}`
            );
          }

          if (qs.correct) {
            // 正确的
            objectiveOriginalNameList.push({
              originalName:
                qs.parentName != null && qs.parentName
                  ? `${qs.parentName}-${qs.originalName}`
                  : qs.originalName,
              status: 0,
            });
          } else {
            if (!qs.status) {
              // 未作答
              objectiveOriginalNameList.push({
                originalName:
                  qs.parentName != null && qs.parentName
                    ? `${qs.parentName}-${qs.originalName}`
                    : qs.originalName,
                status: 2,
              });
              noAnswerScore += qs.question_score;
              noAnswerArr.push(
                qs.parentName != null && qs.parentName
                  ? `${qs.parentName}.${qs.originalName}`
                  : `${qs.originalName}`
              );
              // 未做答的分数
              objectiveGetNoStatusScore += qs.question_score; // 未作答分数
              objectiveGetNoStatusArr.push(
                qs.parentName != null && qs.parentName
                  ? `${qs.parentName}.${qs.originalName}`
                  : `${qs.originalName}`
              );
            } else {
              // 已做答得
              if (qs.score) {
                // 半对
                objectiveOriginalNameList.push({
                  originalName:
                    qs.parentName != null && qs.parentName
                      ? `${qs.parentName}-${qs.originalName}`
                      : qs.originalName,
                  status: 1,
                });
                objectiveHalfScore += qs.score;
                objectiveHalfArr.push(
                  qs.parentName != null && qs.parentName
                    ? `${qs.parentName}.${qs.originalName}`
                    : `${qs.originalName}`
                );
              } else {
                // 做了并且错误
                objectiveOriginalNameList.push({
                  originalName:
                    qs.parentName != null && qs.parentName
                      ? `${qs.parentName}-${qs.originalName}`
                      : qs.originalName,
                  status: 3,
                });
                objectiveLoseScore += qs.question_score;
                objectiveLoseNumber.push(
                  qs.parentName != null && qs.parentName
                    ? `${qs.parentName}.${qs.originalName}`
                    : `${qs.originalName}`
                );
              }
            }
          }
        } else {
          if (qs.correct) {
            subjectiveOriginalNameList.push({
              originalName:
                qs.parentName != null && qs.parentName
                  ? `${qs.parentName}-${qs.originalName}`
                  : qs.originalName,
              status: 0,
            });
          } else {
            if (!qs.status) {
              // 未作答
              subjectiveOriginalNameList.push({
                originalName:
                  qs.parentName != null && qs.parentName
                    ? `${qs.parentName}-${qs.originalName}`
                    : qs.originalName,
                status: 2,
              });
              noAnswerScore += qs.question_score;
              noAnswerArr.push(
                qs.parentName != null && qs.parentName
                  ? `${qs.parentName}.${qs.originalName}`
                  : `${qs.originalName}`
              );
            } else {
              if (qs.score) {
                // 半对
                subjectiveOriginalNameList.push({
                  originalName:
                    qs.parentName != null && qs.parentName
                      ? `${qs.parentName}-${qs.originalName}`
                      : qs.originalName,
                  status: 1,
                });
                subjectiveHalfScore += qs.score;
                subjectiveHalfArr.push(
                  qs.parentName != null && qs.parentName
                    ? `${qs.parentName}.${qs.originalName}`
                    : `${qs.originalName}`
                );
              } else {
                if (!qs.audit_status) {
                  // 做了但未自评
                  subjectiveOriginalNameList.push({
                    originalName:
                      qs.parentName != null && qs.parentName
                        ? `${qs.parentName}-${qs.originalName}`
                        : qs.originalName,
                    status: 4,
                  });
                  // 待批改
                  subjectiveWaitingScore += qs.question_score;
                  subjectiveWaitingNumber.push(
                    qs.parentName != null && qs.parentName
                      ? `${qs.parentName}.${qs.originalName}`
                      : `${qs.originalName}`
                  ); // 客观已失分数
                } else {
                  subjectiveOriginalNameList.push({
                    originalName:
                      qs.parentName != null && qs.parentName
                        ? `${qs.parentName}-${qs.originalName}`
                        : qs.originalName,
                    status: 3,
                  });
                }
              }
            }
          }
        }
      }
      let objectiveOriginalNameArr = [];
      for (let i = 0; i < objectiveOriginalNameList.length; i++) {
        const objective = objectiveOriginalNameList[i];
        if (objective.status != 2) {
          objectiveOriginalNameArr.push(objective);
        }
      }

      let subjectiveOriginalNameArr = [];
      for (let i = 0; i < subjectiveOriginalNameList.length; i++) {
        const subjective = subjectiveOriginalNameList[i];
        if (subjective.status != 2) {
          subjectiveOriginalNameArr.push(subjective);
        }
      }
      let that = this;
      this.pData.total = that.total; // 总分
      this.pData.selfTotalScore = objectiveGetScore; // 已得分数
      this.pData.selfTotalLoseScore = objectiveLoseScore; // 已失分数
      this.pData.objectiveScore = objectiveScore; // 客观题总分
      this.pData.objectiveLoseScore = objectiveLoseScore; // 客观题已经失去的分数
      this.pData.objectiveGetScore = objectiveGetScore; // 客观题已得到分数
      this.pData.objectiveLoseNumber = objectiveLoseNumber; // 客观题已失去分数的题
      this.pData.objectiveGetNumber = objectiveGetNumber; // 客观题已得到分数的题
      this.pData.objectiveGetNoStatusScore = objectiveGetNoStatusScore
        ? objectiveGetNoStatusScore
        : 0; // 客观题未作答分数
      this.pData.objectiveGetNoStatusArr = objectiveGetNoStatusArr; // 客观题未作答数组
      this.pData.subjectiveScore = that.total - objectiveScore; // 主观题总分
      this.pData.subjectiveGetScore = subjectiveGetScore; // 主观题得到的分数
      this.pData.subjectiveLoseScore = subjectiveLoseScore; // 主观题失去的分数
      this.pData.subjectiveHalfScore = subjectiveHalfScore; // 主观题半对的分数
      this.pData.subjectiveHalfArr = subjectiveHalfArr; // 主观题半对的数组
      this.pData.subjectiveWaitingScore = subjectiveWaitingScore; // 主观题待批改分数
      this.pData.subjectiveWaitingNumber = subjectiveWaitingNumber; // 主观题待批改数组的题
      this.pData.scoringRate =
        objectiveDo != 0
          ? ((objectiveGetScore / objectiveDo) * 100).toFixed(2)
          : 0; // 得分率
      this.pData.noAnswerArr = noAnswerArr;
      this.pData.noAnswerScore = noAnswerScore;
      this.pData.objectiveOriginalNameList = objectiveOriginalNameList;
      this.pData.objectiveOriginalNameArr = objectiveOriginalNameArr;
      this.pData.subjectiveOriginalNameList = subjectiveOriginalNameList;
      this.pData.subjectiveOriginalNameArr = subjectiveOriginalNameArr;
      this.pData.objectiveHalfScore = objectiveHalfScore; // 客观题半对得到的分数
      this.pData.objectiveHalfArr = objectiveHalfArr; // 客观题半对得到的分数
      this.getRate();
    },
    getRate() {
      if (+this.appId == 100) {
        this.$HTTP
          .executeGet(
            `${this.$APIS.GET_PAPER_STATISTICS}/${
              this.questionSubmitInfo.paper_id
            }/${0}/${0}`,
            this
          )
          .then((res) => {
            if (res.code == 0) {
              const { data } = res;
              // this.reportInfo = res.data;
              // 数据出来之后要做处理
              this.scoreRate.totalObtainScoreRate = data.cumulativeScoreRate;
              this.scoreRate.expectGkScore = data.expectGkScore;
              // testNum: 0,
              // synthesize: 0
            }
          });
      } else {
        this.$HTTP
          .executeGet(
            `${this.$APIS.GET_PAPER_TOTAL_SCORE}/${this.testId}`,
            this
          )
          .then((res) => {
            const { data, msg } = res;
            // this.submitLoading = false;
            if (res.code == 0) {
              this.scoreRate = data;
            } else {
              this.$message(msg);
            }
          });
      }
    },
    closeWindow() {
      let h = window.location.href;
      if (h.indexOf("continue_evaluation") == -1) {
        try {
          cefJS.sendmsg("passtestformclose");
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          cefJS.sendmsg("mystudytestformclose");
        } catch (error) {
          console.log(error);
        }
      }
    },
    async changeAction(action) {
      await this.$HTTP
        .executeGet(
          `${this.$APIS.VIP_MODIFY_PACKAGE_PAPER_RECORD}/${this.testId}/${action}`,
          this
        )
        .then((res) => {
          if (res.code == 1) {
            this.$message.error(res.msg);
            return false;
          }
        });
    },
    tabelChange(val) {
      let index = this.newQuestionStatus[val.label][0].index;
      this.gotoTarget(index);
    },
    keepon() {
      // try {
      //   cefJS.sendmsg("nosavetest");
      // } catch (error) {
      //   console.log(error);
      // }
      this.dialogServeVisible = false;
      this.tableSavePaperData = [];
      this.$emit("starTime");
    },
    toSelfResult() {
      this.$router.push(
        "/evaluated_detail?paper_id=" +
          this.questionSubmitInfo.paper_id +
          "&test_id=" +
          this.testId +
          "&app_id" +
          this.appId
      );
    },
    toSelfAssessment() {
      this.$root.eventHub.$emit("changePath", "my_evaluation");
      this.$router.push({
        path: "/self_assessment",
        query: {
          paper_id: this.questionSubmitInfo.paper_id,
          test_id: this.testId,
          app_id: this.appId,
          question_type: this.$route.query.question_type,
        },
      });
    },
    gohome() {
      this.$root.eventHub.$emit("changePath", "home");
      this.$router.push("/savesuccess");
      // if(this.appId == 100) {
      //   this.$router.push( `/tfedu_common/expert?id=${this.subjectId}`);
      // } else {
      //   this.$router.push("/tfedu_common/home");
      // }
    },
    toWorngQuestion() {
      if (this.model == "client") {
        // 客户端
        this.$router.push(
          `/client_wrong_topic?subject_id=${this.subjectId}&source=2&pid=${this.questionSubmitInfo.paper_id}&app_id=${this.appId}`
        );
      } else {
        this.$router.push(
          `/wrong_topic?subject_id=${this.subjectId}&source=2&app_id=${this.appId}`
        );
      }
    },
    progressFormat() {
      return `共${this.qsAllNumber}题`;
    },
    timeFormat() {
      return `共${this.allTime}分钟`;
    },
    gotoTarget(indexChanged) {
      localStorage.setItem("flagFirst", "true");
      this.index = indexChanged;
      let qs = this.questionStatus[indexChanged];
      this.id = qs.id;
      this.question_tab = qs.order;
      this.$root.eventHub.$emit(
        "question-tab-changed",
        qs.order,
        qs.id,
        qs.parent_id,
        qs.parent_typeId
      );
      if (
        this.subjectId == 10 ||
        this.subjectId == 12 ||
        this.subjectId == 13 ||
        this.subjectId == 14
      ) {
        for (const key in this.newQuestionStatus) {
          for (
            let index = 0;
            index < this.newQuestionStatus[key].length;
            index++
          ) {
            const element = this.newQuestionStatus[key][index];
            if (element.index == indexChanged) {
              this.tabPosition = key;
              return;
            }
          }
        }
      }
    },
    shamBattleDialogShow() {
      this.submited = true;
      // 需要提前算一下是否有作答的
      // 判断是否有未完成的题目
      let doStatus = false;
      for (let i = 0; i < this.questionStatus.length; i++) {
        const element = this.questionStatus[i];
        if (element.status) {
          doStatus = true;
          break;
        }
      }
      if (!doStatus) {
        this.$message.error("您未做答，请做答后再交卷！");
        return false;
      }

      this.completedQuestions = 0;
      for (let i = 0; i < this.questionStatus.length; i++) {
        const qs = this.questionStatus[i];
        if (qs.status) {
          // 已做答
          this.completedQuestions++;
        }
      }
      this.shamBattleDialog = true;
    },
    shamBattleSubmit() {
      // 实战演练的提交
      //  计算得分,失分,和待批改的分 , 计算主观题|客观题得分,失去分,和待批改分
      //  统计主观题|客观题得分,失分,待批改分,已经作答和未作答的题号
      //总的信息
      let resultScore = this.fullScore;
      let resultError = 0;
      let resultNoComplete = 0;
      //客观题分数信息
      let objectiveScore = 0;
      let objectiveCorrectScore = 0;
      let objectiveErrorScore = 0;
      let correctedScore = 0; // 客观题已做答分数
      let noStatusScore = 0; // 未作答分数
      //客观题题号集合
      let objectiveCorrectNumbers = [];
      let objectiveErrorNumbers = [];
      let unCompleteNumbers = [];
      //主观题分数信息
      let majorScore = 0;
      let majorErrorScore = 0;
      let majorNoCheckScore = 0;
      //主观题题号集合
      let majorErrorNumbers = [];
      let majorNoCheckNumbers = [];
      let majorNoCompleteNumbers = [];
      // 未作答分数
      let noAnswerArr = [];
      // 客观题未作答分数
      let no_do_score = 0;
      let no_do_score_arr = [];
      let qs = this.questionStatus;
      //选做题的集合
      let chooseQuestion = [];
      qs.forEach((q) => {
        if (this.questionIsMajor(q)) {
          majorScore += q.question_score;
          if (q.status) {
            majorNoCheckScore += q.question_score;
            majorNoCheckNumbers.push(q.card_originalName);
          } else {
            noStatusScore += q.question_score;
            noAnswerArr.push(q.card_originalName);
            majorErrorScore += q.question_score;
            majorErrorNumbers.push(q.card_originalName);
            majorNoCompleteNumbers.push(q.card_originalName);
          }
          //如果有主观题的状态是未批改的,则卷子需要批改
          if (!q.audit_status) {
            this.audit_status = false;
          }
          if (!q.status) {
            noStatusScore += q.question_score;
          }
        } else {
          // 新加计算得分率
          if (q.status) {
            // 已做答
            correctedScore += q.question_score;
          } else {
            no_do_score += q.question_score;
            no_do_score_arr.push(q.card_originalName);
            noStatusScore += q.question_score;
          }
          objectiveScore += q.question_score;
          if (q.correct) {
            objectiveCorrectScore += q.question_score;
            objectiveCorrectNumbers.push(q.card_originalName);
          } else {
            if (q.type_id == 40) {
              if (q.score > 0) {
                objectiveCorrectScore += q.score;
                objectiveCorrectNumbers.push(q.card_originalName);
              }
              if (q.status) {
                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              }
            } else {
              if (q.score > 0) {
                objectiveCorrectScore += q.score;
                objectiveCorrectNumbers.push(q.card_originalName);
              }
              if (q.status) {
                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              }
            }
          }
          if (!q.status) {
            unCompleteNumbers.push(q.card_originalName);
            noStatusScore += q.question_score;
          }
        }
      });
      this.submitPaperInfo.objective = {
        score: objectiveScore,
        correct_uncheck: objectiveCorrectScore,
        error_score: objectiveErrorScore,
        correct_number: objectiveCorrectNumbers,
        error_number: objectiveErrorNumbers,
        uncomplete: objectiveErrorNumbers,
        corrected_score: correctedScore,
        noStatusScore: noStatusScore,
        noAnswerArr: noAnswerArr, // 未作答数组
        no_do_score: no_do_score, // 客观题未作答
        no_do_score_arr: no_do_score_arr, // 客观题未作答数组
      };
      this.error_number = objectiveErrorNumbers;
      this.submitPaperInfo.major = {
        score: majorScore,
        correct_uncheck: majorNoCheckScore,
        error_score: majorErrorScore,
        uncheck_number: majorNoCheckNumbers,
        uncomplete: majorNoCompleteNumbers,
      };
      this.correctScore = objectiveCorrectScore;
      this.errorScore = objectiveErrorScore;
      this.unCheckScore = majorNoCheckScore;
      let paper_submit_data = {
        paper_id: this.questionSubmitInfo.paper_id,
        test_id: this.testId,
        user_id: this.questionSubmitInfo.user_id,
        audit_status: this.audit_status,
        questions: this.questionStatus,
        order_number: this.orderNumber || null,
        time_used: this.costTime,
        isAudit: false,
      };
      localStorage.setItem(
        `time_${this.questionSubmitInfo.paper_id}`,
        this.costTime
      );
      // 判断是不是代理商
      //  月卡 &&　次数ｙｏｕ　・・ 次数为0 && compaStatu == 0
      if (!this.monthCardNum) {
        if (this.isAgent) {
          // 是代理商
          // 学科是什么
          if (this.subjectId == 9) {
            // 语文
            if (this.agentInfo.yuwenTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 10) {
            // 数学
            if (this.agentInfo.shuxueTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 11) {
            if (this.agentInfo.yingyuTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 12) {
            if (this.agentInfo.wuliTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          }
        }
      }
      // 判断是否有未完成的题目
      let doStatus = false;
      for (let i = 0; i < this.questionStatus.length; i++) {
        const element = this.questionStatus[i];
        if (!element.status) {
          this.isComplete = true;
        }
        if (element.status) {
          this.allStatus = true;
        }
      }
      for (let i = 0; i < this.questionStatus.length; i++) {
        const element = this.questionStatus[i];
        if (element.status) {
          doStatus = true;
          break;
        }
      }
      if (!doStatus) {
        this.$message.error("您未做答，请做答后再交卷！");
        return false;
      }

      // try {
      //   cefJS.sendmsg("savetest");
      // } catch (error) {
      //   console.log(error);
      // }
      this.submitLoading = true;
      this.$store.dispatch("actionsSetPaperData", paper_submit_data);
      if (+this.appId != 100) {
        this.$HTTP
          .executePost(this.$APIS.PAPER_SUBMIT, paper_submit_data, this)
          .then((res) => {
            if (res.code == 0) {
              this.shamBattleDialog = false;
              this.dialogSubmitVisible = true;
              this.$HTTP
                .executeGet(
                  `${this.$APIS.GET_QUWSTION_OBTAIN}/${this.testId}`,
                  this
                )
                .then((res) => {
                  if (res.code == 0) {
                    this.questionType = res.data || [];
                  }
                });
              this.submitDataAnalysis();
            } else {
              this.$message(res.msg);
            }
            this.submitLoading = false;
          });
      } else {
        this.$HTTP
          .executePost(
            this.$APIS.PUT_EVALUATION_SUBMIT_TEST,
            paper_submit_data,
            this
          )
          .then((res) => {
            if (res.code == 0) {
              this.shamBattleDialog = false;
              this.dialogSubmitVisible = true;
              this.$HTTP
                .executeGet(
                  `${this.$APIS.GET_QUWSTION_OBTAIN}/${this.testId}`,
                  this
                )
                .then((res) => {
                  if (res.code == 0) {
                    this.questionType = res.data || [];
                  }
                });
              this.submitDataAnalysis();
            } else {
              this.$message(res.msg);
            }
            this.submitLoading = false;
          });
      }
    },
    submit_paper() {
      this.submited = true;
      if (this.$route.path.indexOf("continue_evaluation") != -1) {
        // 是继续测评
        let have_card_info = sessionStorage.getItem("have_card_info") || "";
        if (have_card_info == 1) {
          this.changeAction(2);
        }
      } else {
        this.changeAction(2);
      }
      this.$root.eventHub.$emit("test-save-submit-event");
      //  计算得分,失分,和待批改的分 , 计算主观题|客观题得分,失去分,和待批改分
      //  统计主观题|客观题得分,失分,待批改分,已经作答和未作答的题号
      // console.log("fullScore : ",this.fullScore,"this.objectiveScore : ",this.objectiveScore,"this.majorQuesitonScore:",this.majorQuesitonScore);
      //总的信息
      let resultScore = this.fullScore;
      let resultError = 0;
      let resultNoComplete = 0;
      //客观题分数信息
      let objectiveScore = 0;
      let objectiveCorrectScore = 0;
      let objectiveErrorScore = 0;
      let correctedScore = 0; // 客观题已做答分数
      let noStatusScore = 0; // 未作答分数
      //客观题题号集合
      let objectiveCorrectNumbers = [];
      let objectiveErrorNumbers = [];
      let unCompleteNumbers = [];
      //主观题分数信息
      let majorScore = 0;
      let majorErrorScore = 0;
      let majorNoCheckScore = 0;
      //主观题题号集合
      let majorErrorNumbers = [];
      let majorNoCheckNumbers = [];
      let majorNoCompleteNumbers = [];

      // 未作答分数
      let noAnswerArr = [];

      // 客观题未作答分数
      let no_do_score = 0;
      let no_do_score_arr = [];
      let qs = this.questionStatus;

      //选做题的集合
      let chooseQuestion = [];
      qs.forEach((q) => {
        // if(q.parent_typeId!=229 && q.parent_typeId!=234){
        if (this.questionIsMajor(q)) {
          majorScore += q.question_score;
          if (q.status) {
            majorNoCheckScore += q.question_score;
            majorNoCheckNumbers.push(q.card_originalName);
          } else {
            noStatusScore += q.question_score;
            noAnswerArr.push(q.card_originalName);
            majorErrorScore += q.question_score;
            majorErrorNumbers.push(q.card_originalName);
            majorNoCompleteNumbers.push(q.card_originalName);
          }
          //如果有主观题的状态是未批改的,则卷子需要批改
          if (!q.audit_status) {
            this.audit_status = false;
          }
          // if (q.type_id = 39) {
          //   q.audit_status = false
          //   this.audit_status = false
          // }
          if (!q.status) {
            noStatusScore += q.question_score;
          }
        } else {
          // 新加计算得分率
          if (q.status) {
            // 已做答
            correctedScore += q.question_score;
          } else {
            no_do_score += q.question_score;
            no_do_score_arr.push(q.card_originalName);
            noStatusScore += q.question_score;
          }
          objectiveScore += q.question_score;
          if (q.correct) {
            objectiveCorrectScore += q.question_score;
            objectiveCorrectNumbers.push(q.card_originalName);
          } else {
            // if(q.type_code == "E" && q.answerUnicity && q.score > 0){
            //   // if(q.score > 0){
            //   //   objectiveCorrectScore += q.score;
            //   //   objectiveCorrectNumbers.push(q.card_originalName);
            //   // }
            //   // objectiveErrorScore += (q.question_score - q.score);
            //   // objectiveErrorNumbers.push(q.card_originalName);
            // }else
            if (q.type_id == 40) {
              if (q.score > 0) {
                objectiveCorrectScore += q.score;
                objectiveCorrectNumbers.push(q.card_originalName);
              }
              if (q.status) {
                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              }
            } else {
              if (q.score > 0) {
                objectiveCorrectScore += q.score;
                objectiveCorrectNumbers.push(q.card_originalName);
              }
              if (q.status) {
                objectiveErrorScore += q.question_score - q.score;
                objectiveErrorNumbers.push(q.card_originalName);
              }
            }
          }
          if (!q.status) {
            unCompleteNumbers.push(q.card_originalName);
            noStatusScore += q.question_score;
          }
        }
        // }else{
        //     chooseQuestion.push(q);
        // }
      });

      // let map = new Map();
      // //解决选做题的分数
      // for (let i = 0; i < chooseQuestion.length; i++) {
      //   let item = chooseQuestion[i];
      //   if(null == map.get(item.parent_id)){
      //     let array = new Array();
      //     array.push(item)
      //     map.set(item.parent_id,array)
      //   }else{
      //     let array = map.get(item.parent_id);
      //     array.push(item);
      //   }
      // }

      // map.forEach(value=>{
      //   let array = value;
      //   let q = array[0];
      //   if(this.questionIsMajor(q)){
      //     majorScore += q.question_score;
      //   }else{
      //     if (q.status) {
      //       correctedScore += q.question_score;
      //     }
      //     objectiveScore += q.question_score;
      //   }
      //   let status = false;
      //   let audit_status = true;
      //   let correct =false;
      //   //循环内部,只处理题号
      //   array.forEach(q=>{
      //     if(q.status){
      //       status = true;
      //       if(this.questionIsMajor(q)){
      //         majorNoCheckNumbers.push(q.card_originalName);
      //       }
      //     }else{
      //       if(this.questionIsMajor(q)){
      //         majorNoCompleteNumbers.push(q.card_originalName);
      //       }else{
      //         if (!q.correct) {
      //           objectiveErrorNumbers.push(q.card_originalName);
      //         }
      //       }
      //     }
      //     if(!q.audit_status){
      //       audit_status = false;
      //     }
      //     if(!this.questionIsMajor(q)){
      //       if(q.correct){
      //         correct = true;
      //         objectiveCorrectNumbers.push(q.card_originalName);
      //       }else{
      //         if (item.status) {
      //           objectiveErrorNumbers.push(q.card_originalName);
      //         }
      //       }
      //     }
      //   });
      //   //外部 -- > 只处理分数相关
      //   if(status){//如果状态是完成的
      //       //如果是主观题,增加主关未评分数
      //       if(this.questionIsMajor(q)){
      //         majorNoCheckScore += q.question_score;
      //       }
      //   }else{//如果是未完成的,增加未做分数,考虑到是选做题, 则只取一个分数就可以了
      //     if(this.questionIsMajor(q)){
      //       majorErrorScore += q.question_score;
      //     }
      //     // else{
      //     //   objectiveErrorScore += q.question_score;
      //     // }
      //   }
      //   //如果有题是未评的,则卷子改为未平的
      //   if(!audit_status){
      //     if(this.questionIsMajor(q)){
      //       this.audit_status = false;
      //     }
      //   }

      //   //客观题
      //   if(!this.questionIsMajor(q)){
      //     if(correct){//如果是正确的,则添加一个题的分数
      //       objectiveCorrectScore += q.question_score;
      //     }else{
      //       if (status) {
      //         objectiveErrorScore += q.question_score;
      //       }
      //     }
      //   }
      // })

      this.submitPaperInfo.objective = {
        score: objectiveScore,
        correct_uncheck: objectiveCorrectScore,
        error_score: objectiveErrorScore,
        correct_number: objectiveCorrectNumbers,
        error_number: objectiveErrorNumbers,
        uncomplete: objectiveErrorNumbers,
        corrected_score: correctedScore,
        noStatusScore: noStatusScore,
        noAnswerArr: noAnswerArr, // 未作答数组
        no_do_score: no_do_score, // 客观题未作答
        no_do_score_arr: no_do_score_arr, // 客观题未作答数组
      };
      this.error_number = objectiveErrorNumbers;
      this.submitPaperInfo.major = {
        score: majorScore,
        correct_uncheck: majorNoCheckScore,
        error_score: majorErrorScore,
        uncheck_number: majorNoCheckNumbers,
        uncomplete: majorNoCompleteNumbers,
      };
      this.correctScore = objectiveCorrectScore;
      this.errorScore = objectiveErrorScore;
      this.unCheckScore = majorNoCheckScore;
      let paper_submit_data = {
        paper_id: this.questionSubmitInfo.paper_id,
        test_id: this.testId,
        user_id: this.questionSubmitInfo.user_id,
        audit_status: this.audit_status,
        questions: this.questionStatus,
        order_number: this.orderNumber || null,
        time_used: this.costTime,
        isAudit: false,
        // score: this.submitPaperInfo.objective.score + this.submitPaperInfo.major.score,
      };
      localStorage.setItem(
        `time_${this.questionSubmitInfo.paper_id}`,
        this.costTime
      );
      // 判断是不是代理商
      //  月卡 &&　次数ｙｏｕ　・・ 次数为0 && compaStatu == 0
      if (!this.monthCardNum) {
        if (this.isAgent) {
          // 是代理商
          // 学科是什么
          if (this.subjectId == 9) {
            // 语文
            if (this.agentInfo.yuwenTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 10) {
            // 数学
            if (this.agentInfo.shuxueTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 11) {
            if (this.agentInfo.yingyuTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          } else if (this.subjectId == 12) {
            if (this.agentInfo.wuliTimes > 0) {
              paper_submit_data.subject_id = this.subjectId;
              paper_submit_data.charge_id = this.userInfo.id;
            }
          }
        }
      }
      // 判断是否有未完成的题目
      let doStatus = false;
      for (let i = 0; i < this.questionStatus.length; i++) {
        const element = this.questionStatus[i];
        if (!element.status) {
          this.isComplete = true;
        }
        if (element.status) {
          this.allStatus = true;
        }
      }
      for (let i = 0; i < this.questionStatus.length; i++) {
        const element = this.questionStatus[i];
        if (element.status) {
          doStatus = true;
          break;
        }
      }
      if (!doStatus) {
        this.$message.error("您未做答，请做答后再交卷！");
        return false;
      }
      if (this.isComplete) {
        this.$confirm("有未作答的题目 确定要交卷吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // try {
          //   cefJS.sendmsg("savetest");
          // } catch (error) {
          //   console.log(error);
          // }

          this.dialogSubmitVisible = true;
          this.submitLoading = true;
          this.$store.dispatch("actionsSetPaperData", paper_submit_data);

          if (+this.appId != 100) {
            this.$HTTP
              .executePost(this.$APIS.PAPER_SUBMIT, paper_submit_data, this)
              .then((res) => {
                if (res.code == 0) {
                  this.$HTTP
                    .executeGet(
                      `${this.$APIS.GET_QUWSTION_OBTAIN}/${this.testId}`,
                      this
                    )
                    .then((res) => {
                      if (res.code == 0) {
                        this.questionType = res.data || [];
                      }
                    });
                  this.submitDataAnalysis();
                } else {
                  this.$message(res.msg);
                }
                this.submitLoading = false;
              });
          } else {
            paper_submit_data.questionType =
              this.$route.query.question_type || null;
            this.$HTTP
              .executePost(
                this.$APIS.PUT_EVALUATION_SUBMIT_TEST,
                paper_submit_data,
                this
              )
              .then((res) => {
                if (res.code == 0) {
                  this.$HTTP
                    .executeGet(
                      `${this.$APIS.GET_QUWSTION_OBTAIN}/${this.testId}`,
                      this
                    )
                    .then((res) => {
                      if (res.code == 0) {
                        this.questionType = res.data || [];
                      }
                    });
                  this.submitDataAnalysis();
                } else {
                  this.$message(res.msg);
                }
                this.submitLoading = false;
              });
          }
        });
      } else {
        this.dialogSubmitVisible = true;
        this.submitLoading = true;
        this.$store.dispatch("actionsSetPaperData", paper_submit_data);
        if (+this.appId != 100) {
          this.$HTTP
            .executePost(this.$APIS.PAPER_SUBMIT, paper_submit_data, this)
            .then((res) => {
              if (res.code == 0) {
                this.$HTTP
                  .executeGet(
                    `${this.$APIS.GET_QUWSTION_OBTAIN}/${this.testId}`,
                    this
                  )
                  .then((res) => {
                    if (res.code == 0) {
                      this.questionType = res.data || [];
                    }
                  });
                this.submitDataAnalysis();
                // this.submitDataAnalysis()
              } else {
                console.log(msg);
              }
              this.submitLoading = false;
            });
        } else {
          paper_submit_data.questionType =
            this.$route.query.question_type || null;
          this.$HTTP
            .executePost(
              this.$APIS.PUT_EVALUATION_SUBMIT_TEST,
              paper_submit_data,
              this
            )
            .then((res) => {
              if (res.code == 0) {
                this.submitDataAnalysis();
                // this.submitDataAnalysis()
              } else {
                console.log(msg);
              }
              this.submitLoading = false;
            });
        }
      }
    },
    async save_paper() {
      // try {
      //   cefJS.sendmsg("savetest");
      // } catch (error) {
      //   console.log(error);
      // }
      if (this.$route.path.indexOf("continue_evaluation") != -1) {
        // 是继续测评
        let have_card_info = sessionStorage.getItem("have_card_info") || "";
        if (have_card_info == 1) {
          this.changeAction(1);
        }
      } else {
        this.changeAction(1);
      }
      this.$root.eventHub.$emit("test-save-submit-event");
      this.dialogServeVisible = true;
      this.$emit("clearTimer");
      let qs = this.questionStatus;
      //总体数,客观题 : 数量,已作答数,客观题: 数量,已作答数
      let questionNumber = 0;
      let objectiveNumber = 0;
      let objectiveRespondNumber = 0;
      let objectiveNoRespondNumber = 0;
      let majorNumber = 0;
      let majorRespondNumber = 0;
      let majorNoRespondNumber = 0;
      questionNumber = qs.length;
      qs.forEach((q) => {
        if (this.questionIsMajor(q)) {
          majorNumber++;
          if (q.status) {
            majorRespondNumber++;
          }
        } else {
          if (q.status) {
            objectiveRespondNumber++;
          }
        }
      });
      objectiveNumber = questionNumber - majorNumber;
      majorNoRespondNumber = majorNumber - majorRespondNumber;
      objectiveNoRespondNumber = objectiveNumber - objectiveRespondNumber;

      this.savePaperInfo = {
        major: {
          count: majorNumber,
          complete: majorRespondNumber,
          uncomplete: majorNoRespondNumber,
        },
        objective: {
          count: objectiveNumber,
          complete: objectiveRespondNumber,
          uncomplete: objectiveNoRespondNumber,
        },
      };
      this.saveLoading = true;
      let paper_submit_data = {
        paper_id: this.questionSubmitInfo.paper_id,
        test_id: this.testId,
        user_id: this.questionSubmitInfo.user_id,
        audit_status: false, //批改状态为false
        questions: this.questionStatus,
        time_used: this.costTime,
      };
      await this.$HTTP
        .executePost(this.$APIS.PAPER_SAVE, paper_submit_data, this)
        .then((res) => {
          if (res.code == 0) {
            this.dialogServeVisible = true;
          } else {
            this.$message.error("保存失败请重试！");
          }
          this.saveLoading = false;
        });
    },
    questionIsMajor(question) {
      if (question.type_code == "S" || question.type_code == "E") {
        return true;
      }
      // if(question.type_code == "E" && !question.answerUnicity){
      //   return true;
      // }
      return false;
    },
    // 写一个函数来执行
    async getChance(cData) {
      let monthIsOk = false;
      let user_json = localStorage.getItem("userinfo");
      let userInfo = JSON.parse(user_json);
      for (let i = 0; i < cData.length; i++) {
        const element = cData[i];
        if (element.subjects.indexOf(this.subjectId) != -1) {
          this.monthNum = element.paperNum;
          this.answerTimes = element.answerTimes;
          let sParams = {
            userId: userInfo.id,
            subjectId: this.subjectId,
            createDate: new Date(element.createTime),
            endDate: new Date(element.createTime + element.indate),
          };
          await this.$HTTP
            .executePost(this.$APIS.GET_CARD_INFOPAPER_NUM, sParams, this)
            .then((res) => {
              if (res.code === 0) {
                if (res.data != null && res.data.length) {
                  let isPaper = false; // 当前试卷是否存在
                  for (let j = 0; j < res.data.length; j++) {
                    const element = res.data[j];
                    if (element.paperId == this.questionSubmitInfo.paper_id) {
                      isPaper = true;
                    }
                  }
                  if (isPaper) {
                    // 存在
                    for (let z = 0; z < res.data.length; z++) {
                      const element2 = res.data[z];
                      if (
                        element2.paperId == this.questionSubmitInfo.paper_id
                      ) {
                        if (element2.completeTimes < this.answerTimes) {
                          this.monthCardNum = 1;
                          return false;
                        }
                        // if (element2.completeStatus == 0 && res.data.length <= this.monthNum) { // 未完成
                        //   this.monthCardNum = 1
                        //   return false
                        // }
                      }
                    }
                  } else {
                    // 不存在
                    if (res.data.length < this.monthNum) {
                      this.monthCardNum = 1;
                      return false;
                    }
                  }
                } else {
                  this.monthCardNum = 1;
                  return false;
                }
              }
            });
        }
      }
    },
    sendMessageToClient() {
      try {
        let questionId = this.id;
        let paperId = this.questionSubmitInfo.paper_id;
        let subjectId = this.subjectId;
        this.$HTTP
          .executeGet(
            `${this.$APIS.GET_KNOWLEDGE_POINT_BY_QUESTIONID}/${questionId}`,
            this
          )
          .then((res) => {
            if (res.code == 0) {
              let pointId = res.data != null ? res.data : [];
              let sendMsg = `{"code":5,"data":"subjectId=${subjectId}&paperId=${paperId}&questionId=${questionId}&knowledgeId=${pointId}"}`;
              // let msg = `code=5&subjectId=${subjectId},paperId=${paperId},questionId=${questionId},knowledgeId=${pointId}`
              // let stringMsg = JSON.stringify(sendData)
              cefJS.sendmsg(sendMsg);
              console.log("" + sendMsg + "");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.appId = this.$route.query.app_id;
    this.question_type = this.$route.query.question_type;
    this.model = localStorage.getItem("model") || this.$route.query.model || "";
    let user_json = localStorage.getItem("userinfo");
    let userInfo = JSON.parse(user_json);
    this.userName = userInfo.fullName || userInfo.nickname || userInfo.name;
    this.$HTTP
      .executeGet(`${this.$APIS.GET_VIP_CARD_INFO}/${userInfo.id}/1`, this)
      .then((res) => {
        if (res.code == 0) {
          // 是有月卡
          let mate = false;
          if (res.data != null) {
            for (let index = 0; index < res.data.length; index++) {
              const element = res.data[index];
              if (element.subjects.indexOf(this.subjectId) != -1) {
                mate = true;
              }
            }
          }
          // 有月卡
          if (mate) {
            this.getChance(res.data);
          } else {
            this.monthCardNum = 0;
          }
        }
      });
  },
  mounted() {
    this.curPath = window.location.hostname;
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error);
    }
    try {
      cefJS.sendmsg("savetest");
    } catch (error) {
      console.log(error);
    }
    window.addEventListener("beforeunload", () => {
      if (!this.submited) {
        this.save_paper();
      }
    });
    this.id = this.questionStatus[0].id;
    this.question_tab = this.questionStatus[0].order;
    this.tabPosition = "1";
    this.orderNumber = this.$route.query.order_number;
    this.$root.eventHub.$emit(
      "question-tab-changed",
      this.question_tab,
      this.questionStatus[0].id,
      this.questionStatus[0].parent_id,
      this.questionStatus[0].parent_typeId
    );
    this.$root.eventHub.$on("question-tab-changed1", (order) => {
      let array = this.questionStatus;
      for (let index = 0; index < array.length; index++) {
        let element = array[index];
        if (element.order == order) {
          this.index = index;
          this.id = element.id;
          this.question_tab = element.order;
        }
      }
    });

    let user_json = localStorage.getItem("userinfo");
    this.userInfo = JSON.parse(user_json);
    this.$HTTP
      .executeGet(`${this.$APIS.GET_BY_CHAGEID}/${this.userInfo.id}`, this)
      .then((res) => {
        if (!res.code) {
          // 是代理商
          if (res.data != null && res.data.id) {
            // 是代理商
            this.isAgent = true;
            this.agentInfo = res.data;
          }
        } else {
          console.log("不是代理商");
        }
      });
  },
  destroyed() {
    if (!this.submited) {
      this.save_paper();
    }
  },
};
</script>
<style lang="stylus" scoped>
.question_card {
  width: 400px;
  position: fixed;
  height: 99%;
  z-index: 1000;
  background-color: #f5f5f5;
  margin-left: 12px;

  .card {
    width: 298px;
    overflow: hidden;
    height: 500px;
    border: 1px #5c307d solid;
    margin-top: 30px;
    margin-left: 30px;
    background-color: #ffffff;

    .nav {
      width: 300px;
      height: 38px;
      background-color: #5c307d;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
    }

    .comparison {
      width: 300px;
      height: 45px;
      margin-top: 25px;

      .already {
        width: 20px;
        height: 20px;
        margin-left: 60px;
        background-color: #f0f0f0;
        border: 1px #d5d5d5 solid;
        float: left;
      }

      .not_yet {
        width: 20px;
        height: 20px;
        margin-left: 25px;
        background-color: #ffffff;
        border: 1px #5c307d solid;
        float: left;
      }

      span {
        font-size: 19px;
        color: #5c307d;
        margin-left: 10px;
        float: left;
      }
    }

    .number_list {
      width: 300px;
      height: 380px;
      padding-bottom: 5px;
      overflow-x: hidden;

      .already {
        width: 55px;
        height: 38px;
        border: 1px #d5d5d5 solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
        background-color: #f0f0f0;
        color: #bebebe;
        cursor: pointer;
      }

      .not_yet {
        width: 55px;
        height: 38px;
        border: 1px #5c307d solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffffff;
        cursor: pointer;
      }

      .choose {
        width: 55px;
        height: 38px;
        border: 1px #5c307d solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #f1dfff;
        cursor: pointer;
      }
    }

    .number_list_wen {
      width: 300px;
      max-height: 380px;
      overflow-x: hidden;
      display: -webkit-flex;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 24px;
      padding-bottom: 5px;

      .already {
        width: 68px;
        height: 38px;
        border: 1px #d5d5d5 solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
        background-color: #f0f0f0;
        color: #bebebe;
        cursor: pointer;
      }

      .not_yet {
        width: 68px;
        height: 38px;
        border: 1px #5c307d solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffffff;
        cursor: pointer;
      }

      .choose {
        width: 68px;
        height: 38px;
        border: 1px #5c307d solid;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #f1dfff;
        cursor: pointer;
      }
    }

    .number_list_wen:after {
      content: '';
      width: 68px;
    }
  }

  .btns {
    width: 330px;
    height: 130px;
    position: relative;
    float: left;

    .btn {
      width: 110px;
      height: 50px;
      margin-left: 35px;
      margin-top: 30px;
      background-color: #5c307d;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      float: inherit;
      line-height: 1;
    }

    .btn-dis {
      width: 110px;
      height: 50px;
      margin-left: 35px;
      margin-top: 30px;
      background-color: #aaaaaa;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      float: inherit;
      line-height: 1;
    }

    .btn:hover {
      background-color: #ff3a00;
    }
  }
}
</style>
<style lang="scss" scoped>
.success-submit-new-dialog {
  /deep/ .el-dialog__header {
    padding: 0;
    display: none;
  }
  /deep/ .el-dialog__body {
    font-size: 18px;
    padding: 0 !important;
    margin: 0 !important;
  }
  .paper-name {
    width: 100%;
    text-align: center;
    font-size: 22px;
    line-height: 53px;
  }
  .pop-name {
    width: 100%;
    text-align: center;
    font-size: 22px;
    font-weight: 800;
  }
  .content {
    width: 100%;
    max-width: 1040px;
    border: 1px solid #ace292;
    background-color: #f4ffef;
    margin: 0 auto;
    margin-top: 30px;
    border-radius: 8px;
    color: #585858;
    .new-tip {
      text-align: left;
      text-indent: 2em;
      padding: 10px 20px;
    }
    .scoring {
      width: 100%;
      font-size: 26px;
      text-align: center;
      span {
        font-size: 32px;
        font-weight: 800;
        color: #ff0000;
      }
    }
    .ping-yu {
      font-size: 18px;
      line-height: 40px;
      padding: 20px;
      text-indent: 2em;
    }
    .ping-msg {
      font-size: 18px;
      line-height: 40px;
      padding: 20px;
      .item-msg {
        text-align: left;
        text-indent: 2em;
        font-weight: 600;
      }
      .item-cont {
        text-indent: 2em;
        .item {
          font-weight: 600;
        }
      }
    }
    h3 {
      font-size: 20px;
      font-weight: 800;
      line-height: 74px;
      padding-left: 30px;
    }
    p {
      font-size: 20px;
      text-align: center;
      line-height: 40px;
      span {
        font-size: 25px;
        font-weight: 800;
        vertical-align: bottom;
      }
    }

    .blue {
      color: #83c000;
    }

    .red {
      color: #ff0000;
    }

    .content-box {
      height: auto;
      width: 910px;
      margin: 0 auto;
      margin-top: 20px;
      .left {
        display: inline-block;
        vertical-align: top;
        font-size: 18px;
        line-height: 30px;
        margin-left: 30px;
      }
      .show-status {
        display: inline-block;
        vertical-align: top;
        overflow: auto;
        width: 780px;
        .item {
          height: 60px;
          min-width: 30px;
          float: left;
          margin-left: 10px;
          margin-bottom: 20px;
          .origin-name {
            height: 30px;
            display: block;
            width: auto;
            min-width: 30px;
            text-align: center;
            line-height: 30px;
            background: #aaaaaa;
            color: #fff;
            font-size: 15px;
            border-radius: 4px;
          }
          .origin-img {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            .w22 {
              width: 22px;
            }
            .w17 {
              width: 17px;
            }
          }

          .bgred {
            background: #ff0000;
          }

          .bgblue {
            background: #83c000;
          }

          .bgblack {
            background: #000000;
          }
          .bgbandui {
            background: #ff9000;
          }
        }
      }
    }
    .button {
      text-align: center;
      button {
        width: 170px;
        height: 50px;
        border-radius: 4px;
        border: none;
        outline: none;
        background-color: #3db0f0;
        color: #fff;
        font-size: 20px;
        margin-bottom: 30px;
        cursor: pointer;
      }
      .right {
        margin-left: 40px;
      }
    }

    .content-tabel {
      margin: 20px 30px;
      tr {
        font-size: 16px;
        th {
          font-size: 16px;
          text-align: center;
          font-weight: 800;
        }
        .q-type {
          width: 170px;
        }
        .q-rate {
          width: 94px;
        }
        .q-td-rate {
          color: #ff8787;
          font-weight: 800;
        }
        .q-tip {
          line-height: 33px;
          padding-left: 50px;
        }
      }
      .th-header {
        background: #d6f3c8;
        height: 50px;
      }

      tr:nth-child(even) {
        /*偶数行*/
        background: #fff;
      }
    }

    .content-detail {
      padding: 20px 30px;
      width: 100%;
      font-size: 16px;
      .th-header {
        height: 50px;
        th {
          text-align: center;
          font-weight: 800;
        }
      }
      tr {
        height: 64px;
        border-bottom: 1px solid #ffc4c4;
        td {
          .w22 {
            width: 22px;
          }
          .w17 {
            width: 17px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.success-serve-dialog {
  height: 534px;
  width: 951px;
  .el-dialog__body {
    font-size: 18px;
    padding: 0 !important;
    margin: 0 !important;
    height: 400px;
  }
  .title {
    padding: 0 !important;
    margin: 0 !important;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
      border-radius: 25px;
    }

    h3 {
      font-size: 23px;
      margin-left: 30px;
      color: #272727;
    }
  }
  .table-container {
    padding: 0 !important;
    margin: 0 !important;
    display: -webkit-flex;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 450px;
    width: 100%;
    /deep/ .el-table {
      width: auto !important;
      max-width: 647px !important;
    }
    .item {
      height: 50px;
      width: 471px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .count {
        display: inline-block;
      }
      .number {
        display: inline-block;
      }
      .unnumber {
        display: inline-block;
      }
    }
  }
  .table-container-submit {
    padding: 0 !important;
    margin: 0 !important;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 350px;
    width: 100%;
    /deep/ .el-table {
      width: auto !important;
      max-width: 647px !important;
    }
  }
  .table-container-submit2 {
    height: 450px;
    width: 100%;
    .summarize {
      width: 100%;
      float: left;
      height: 30px;
      line-height: 50px;
      text-align: center;
      h3 {
        font-size: 18px;
      }
    }
    .table {
      margin-left: 68px;
      margin-top: 20px;
      float: left;
      width: auto;
      height: 291px;
      border: 1px solid #aaaaaa;
      border-bottom: none;
      border-right: none;
      .item {
        display: flex;
        width: auto;
        height: 145px;
        border-bottom: 1px solid #aaaaaa;
        .first {
          height: 144px;
          width: 211px;
          border-right: 1px solid #aaaaaa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .line {
            width: 100%;
            font-size: 18px;
            text-align: center;
            padding: 15px auto;
            overflow-y: auto;
            min-height: 20%;
            .number {
              display: inline-block;
              border: 1px solid #67b8ff;
              min-width: 30px;
              height: 30px;
              color: #67b8ff;
              line-height: 1.45;
              font-size: 12px;
              margin-left: 10px;
              padding-left: 2px;
              padding-right: 2px;
              margin-top: 10px;
              line-height: 30px;
            }
          }
        }
        .two {
          height: 143px;
          width: 300px;
          border-right: 1px solid #aaaaaa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .line {
            width: 100%;
            font-size: 16px;
            padding: 15px auto;
            overflow-y: auto;
            min-height: 20%;
            .number {
              text-align: center;
              display: inline-block;
              border: 1px solid #67b8ff;
              min-width: 30px;
              height: 30px;
              color: #67b8ff;
              font-size: 12px;
              margin-left: 10px;
              padding-left: 2px;
              padding-right: 2px;
              justify-content: center;
              margin-top: 10px;
              line-height: 30px;
            }
          }
          .head {
            text-align: center;
          }
        }
      }
    }
  }
}

.el-progress-bar {
  width: 80%;
}

.progress-time-box {
  width: 76%;
  margin-left: 136px;
  margin-top: 119px;

  >>> .progressbar {
    .el-progress__text {
      font-size: 18px !important;
    }
  }
}

.el-progress-bar {
  width: 100%;
}

.el-progress__text {
  font-size: 18px !important;
}
>>> .el-carousel__arrow {
  top: 68% !important;
}
</style>

<style lang="scss" scoped>
/deep/ .battle-sham-dialog {
  width: 800px;
  height: auto;

  .el-dialog__header {
    padding: 0;
    height: 50px;
    width: 100%;
    background: #3db0f0;
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
      line-height: 50px;
    }
  }
  .el-dialog__body {
    .content {
      font-size: 18px;
      line-height: 46px;
      color: #3c3c3c;
      padding: 0 70px;
      p{
        text-indent: 2em;
      }
    }

    .button {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      margin-top: 60px;
      button {
        width: 100px;
        height: 35px;
        background: #3db0f0;
        font-size: 16px;
        color: #fff;
        border-radius: 4px;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
  }
}
</style>
